import { render, staticRenderFns } from "./VanFilters.vue?vue&type=template&id=54bf868a&scoped=true&"
import script from "./VanFilters.vue?vue&type=script&lang=ts&"
export * from "./VanFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf868a",
  null
  
)

export default component.exports